var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.title)+": ")]),_c('kst-list',{attrs:{"items":_vm.theItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }